import _ from 'lodash'
import { bindActionCreators } from 'redux'
import { analyticsPageViewEvent } from 'analytics/actions'
import moment from 'moment'
import Mustache from 'mustache'
import { christianToThaiDate } from 'core/service/lib/date'
import { omit, keyBy, isNil, isEmpty, defaultTo, orderBy, size, flow, get, map, sum, isEqual, head } from 'lodash/fp'
import styled, { css } from 'styled-components'
import {
  branch,
  renderComponent,
  compose,
  lifecycle,
  withProps,
  setDisplayName,
  withHandlers,
  withState,
  mapProps,
} from 'recompose'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Box, Flex } from 'rebass'
import { Alert, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'

import Button from 'e-submission/components/Button'
import Content from 'e-submission/components/Layout/Content'
import FormSection from 'e-submission/components/Layout/FormSection'
import Card from 'e-submission/components/Card'
import ApplicationCard from 'e-submission/components/Card/ApplicationCard'
import { contentMaxWidth } from 'e-submission/components/mixins'

import { isLoggedIn, isBancAgent } from 'identity/selectors'

import { getToggles } from 'quick-quote/feature-toggles'

import { getActiveBasicPlanCampaignDiscount } from 'core/service/basic-plan/basic-plan'

import {
  getReplicationStatus,
  getAppList,
  getPreparedAppInformation,
  submittedFlashMessage,
  getProductsPayload,
  getProductsDisplay,
} from 'e-submission/apps/selectors'
import {
  subscribeReplicationStatus,
  unsubscribeReplicationStatus,
  fetchApplication,
  changeCurrentApp,
  hideSubmittedFlashMessage,
  mergeApplication,
  clickApplicationCard,
  reValidateAge,
  reGenBI,
  setAppValue,
  markCheckedPremiumCalStatus,
  saveNewBI,
  iProLoadApp,
} from 'e-submission/apps/actions'

import { REPLICATION_STATUS, APP_STATUS } from 'e-submission/domain/data-model/constants'
import {
  isCordova,
  housekeepingStatusSignedFlow,
  housekeepingStatusDraftedFlow,
  IsRealDevice,
} from 'e-submission/utils'
import { loginRequest } from 'quick-quote/actions'
import { setNotificationMessage } from 'quick-quote/notification/actions'

import { getQueryParam } from 'quick-quote/opty/utils'
import ROUTE_PATH from 'quick-quote/constants/path'
import { getAppByOptyId } from 'e-submission/domain/service/opty'
import { listApplicationSummary } from 'e-submission/domain/service/application'
import { Modal } from 'common-components/index'
import Icon from 'e-submission/components/Icon'
import React from 'react'
import Dialog from 'e-submission/components/Dialog'
import EkycRevalidateAge from 'e-submission/containers/Dialog/EkycRevalidateAge'
// import { appsData } from './data'

export const FailedMessage = styled(({ className }) => (
  <Alert color={'danger'} isOpen={true} className={className}>
    ระบบตรวจพบข้อมูล/เอกสารไม่สมบูรณ์
    <ol>
      <li>กรุณากดปิดหน้าจอ X แล้ว กดนำส่ง อีก 1-2 ครั้ง</li>
      <li>หากไม่สามารถนำส่งได้ กรุณาถ่ายรูปหน้าจอนี้</li>
      <li>ส่งภาพต่อไปยังทีม Support ผ่าน LINE หรือ ติดต่อ 1159</li>
      <li>รอการติดต่อกลับจากเจ้าหน้าที่</li>
    </ol>
  </Alert>
))``
export const SubmittingMessage = styled(({ className }) => (
  <Alert color={'warning'} isOpen={true} className={className}>
    เอกสารระหว่างนำส่งหลังบ้าน
    <ul>
      <li>กรุณาอย่าปิด app</li>
      <li>กรุณาอย่า log in บนเครื่องอื่น</li>
    </ul>
  </Alert>
))``

/* istanbul ignore next */
const _ReplicationMessage = styled(({ className, replicationStatus, isLoggedIn }) => {
  if (!isCordova || !isLoggedIn) {
    return null
  }

  let color = 'success'
  let message = ''
  if (replicationStatus === REPLICATION_STATUS.ACTIVE) {
    message = (
      <div>
        กำลังอัพเดทข้อมูล <div id="spinner" />
      </div>
    )
    color = 'info'
  } else if (replicationStatus === REPLICATION_STATUS.IDLE) {
    message = 'อัพเดทข้อมูลสำเร็จ'
  } else if (replicationStatus === REPLICATION_STATUS.OFFLINE) {
    message = 'ยังไม่สามารถอัพเดทข้อมูลได้ กรุณาเปิดเน็ต แล้วรอสักครู่'
    color = 'danger'
  }

  return (
    <Alert color={color} isOpen={true} className={className}>
      {message}
    </Alert>
  )
})`
  #spinner {
    float: right;
    width: 20px;
    height: 20px;
    border-left-color: ${({ theme }) => theme.variables['$color-venice-blue']};
  }
`
/* istanbul ignore next */
const AppContent = Content.extend`
  ${({ theme }) => theme.media.xl`
    ${contentMaxWidth({ size: 'xl' })}
    .appWrap {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      ${AppSection} {
        flex: 0 0 32%;
        &:last-child {
          margin-right: 0;
        }
      }
      ${AppSection}:first-child {
        flex: 1 1 100%;
        > div {
          width: 32%;
        }
      }
    }
  `};
`

const AppSection = styled(Box)`
  padding-bottom: 40px;
`
const AppTitle = styled(Box)`
  padding: 5px 5px 5px 15px;
  ${() =>
    getToggles().ENABLE_APP_LIST_STICKY_HEADER &&
    css`
      position: sticky;
      top: 50px;
      background-color: #f5f5f5;
      padding-top: 10px;
    `}
  ${({ theme }) => theme.media.md`
    padding-left: 0;
  `};
  .box {
    display: flex;
  }
  .dot-status {
    border-radius: 50%;
    width: 22px;
    height: 22px;
    text-align: center;
    margin: 10px;
  }
  .dot-drafted {
    background-color: #5f5f5f;
  }
  .dot-signed {
    background-color: #eb4d33;
  }
  .dot-signed-over {
    background-color: #fcd385;
  }
  .dot-signed-disabled {
    background-color: #e5e5e5;
  }
  .status-msg {
    margin: auto;
    font-size: 0.8rem;
  }
  @media only screen and (min-width: 1200px) {
    .undertitle {
      margin: 8px;
    }
  }
  @media only screen and (max-width: 1199px) {
    .undertitle {
      display: none;
    }
  }
`
/* istanbul ignore next */
const UnderTitleStatus = styled(({ status }) => {
  if (status === APP_STATUS.SIGNED) {
    return (
      <div className="box">
        <div className="box">
          <div className="dot-status dot-signed"></div>
          <div className="status-msg">สถานะปกติ </div>
        </div>
        <div className="box">
          <div className="dot-status dot-signed-over"></div>
          <div className="status-msg">ยกเลิกการขาย ในกรณีรับเงินแล้ว</div>
        </div>
        <div className="box">
          <div className="dot-status dot-signed-disabled"></div>
          <div className="status-msg">ยกเลิกการขาย</div>
        </div>
      </div>
    )
  } else if (status === APP_STATUS.DRAFTED) {
    return (
      <div className="box">
        <div className="box">
          <div className="dot-status dot-drafted"></div>
          <div className="status-msg">กำลังเปิดการขาย </div>
        </div>
        <div className="box">
          <div className="dot-status dot-signed-disabled"></div>
          <div className="status-msg">ยกเลิกการขาย</div>
        </div>
      </div>
    )
  }
  return <div className="undertitle">&nbsp;</div>
})``

const _SubmittedFlashMessage = styled(
  ({ hasSubmittedFlashMessage, hideSubmittedFlashMessage, name, policyId, className }) => (
    <Alert color="success" isOpen={hasSubmittedFlashMessage} toggle={hideSubmittedFlashMessage} className={className}>
      นำส่งเอกสาร #{policyId} ของ {name} เสร็จแล้ว
    </Alert>
  )
)`
  .close {
    font-size: 1rem;
  }
`
const SubmittedFlashMessage = connect(
  (state, { latestSubmitted }) => ({
    ...getPreparedAppInformation(state, { appId: latestSubmitted._id }),
    hasSubmittedFlashMessage: submittedFlashMessage(state),
  }),
  { hideSubmittedFlashMessage }
)(_SubmittedFlashMessage)

const _CustomerDisclaimerMessage = ({ isBancUser }) => {
  return !isBancUser ? null : (
    <Alert color={'info'}>
      ข้อมูลที่ลูกค้าควรรับทราบมีดังนี้
      <ol>
        <li>ลูกค้ามีสิทธิ์ขอยกเลิกกรมธรรม์ ภายใน 15 วันนับแต่วันที่ได้รับกรมธรรม์</li>
        <li>
          สิทธิ์ที่ลูกค้าควรทราบ ในกรณีมีเหตุจำเป็นต้องหยุดส่งเบี้ยประกัน, การกู้เงินตามกรมธรรม์,
          สิทธิ์ของมูลค่าเงินสำเร็จ, สิทธิ์การขยายเวลา
        </li>
        <li>ช่องทางการติดต่อ</li>
      </ol>
    </Alert>
  )
}

export const CustomerDisclaimerMessage = compose(
  connect((state) => ({
    isBancUser: isBancAgent(state),
  }))
)(_CustomerDisclaimerMessage)

const _PremiumCalStatusInvalidDialog = ({ isOpen, onConfirm, dispatch }) => {
  return (
    <Modal
      isOpen={isOpen}
      backdrop={true}
      size="md"
      modalClassName="default-bootstrap login-session-limit-selling-modal"
    >
      <ModalHeader>ใบคำขอนี้ไม่สามารถใช้งานได้</ModalHeader>
      <ModalBody>
        <p>เนื่องจากอายุรับประกันไม่เข้าเงื่อนไข ส่งผลให้ใบคำขอนี้ไม่สามารถใช้งานได้</p>
        <p>กรุณากด ยืนยัน เพื่อเปลี่ยนแบบประกัน</p>
      </ModalBody>
      <ModalFooter>
        <div className="bottom">
          <Button
            color="primary"
            onClick={() => {
              dispatch(changeCurrentApp(''))
              onConfirm()
            }}
          >
            ยืนยัน
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  )
}

export const PremiumCalStatusInvalidDialog = compose(
  withRouter,
  withHandlers({
    onConfirm: ({ history }) => () => {
      history.push('/')
    },
  }),
  connect((state, dispatch) => ({
    isOpen:
      _.get(state, ['apps', 'byId', `${_.get(state, ['apps', 'currentAppId'])}`, 'checkedPremiumCalStatus'], 'Y') ===
        'N' && _.get(state, ['apps', 'byId', `${_.get(state, ['apps', 'currentAppId'])}`, 'ageChange'], 'Y') === 'Y',
    state,
    dispatch,
  }))
)(_PremiumCalStatusInvalidDialog)

const PremiumChangeModal = styled(Dialog)`
  .modal-header {
    padding: 20px;
  }
  .modal-title {
    display: flex;
    flex: 1 0 auto;
    font-weight: bold;
    margin-left: 30px;
    justify-content: space-between;
    color: ${({ theme }) => theme.variables['$brand-primary']};
  }
  .btn-right {
    color: #555555;
  }
  .modal-body {
    padding: 50px 20px;
    align-items: center;
    background: white;
    display: flex;
    flex-direction: column;
    button {
      margin: 10px;
      width: 70%;
      @media (min-width: 768px) {
        width: 50%;
      }
    }
  }
`

const _PremiumChangeDialog = ({ isOpen, isLoading, onExit, dispatch, newTotalPremium, appId }) => {
  let bodyContent = (
    <>
      <p>เนื่องจากอายุผู้เอาประกันมีการปรับเปลี่ยนส่งผลกระทบต่อเบี้ยประกัน</p>
      <p>
        เบี้ยประกันใหม่{' '}
        <i style={{ color: '#2425aa', fontWeight: 'bold', fontStyle: 'normal' }}>{newTotalPremium.toLocaleString()}</i>{' '}
        บาท
      </p>
      <p>กรุณากด ยืนยัน เพื่อดำเนินการตามขั้นตอนถัดไป</p>
    </>
  )
  let footerContent = (
    <div className="bottom">
      <Button
        color="primary"
        onClick={() => {
          dispatch(saveNewBI())
        }}
      >
        ยืนยัน
      </Button>
    </div>
  )

  return (
    <PremiumChangeModal isOpen={isOpen && !isLoading} backdrop={true} size="md" modalClassName="default-bootstrap">
      <ModalHeader tag="div">
        <div />
        <div>แจ้งเปลี่ยนแปลงเบี้ยประกัน</div>
        <div></div>
      </ModalHeader>
      <ModalBody>{bodyContent}</ModalBody>
      <ModalFooter>{footerContent}</ModalFooter>
    </PremiumChangeModal>
  )
}

export const PremiumChangeDialog = compose(
  withRouter,
  withHandlers({
    onExit: ({ history }) => () => {
      history.push('/')
    },
  }),
  connect((state, dispatch) => {
    return {
      isOpen: _.get(state, ['ui', 'isAgeRevalidating'], false),
      newTotalPremium: _.get(
        state,
        ['apps', 'byId', `${_.get(state, ['apps', 'currentAppId'])}`, 'newPremiumCalData', 'totalPremium'],
        'NaN'
      ),
      appId: `${_.get(state, ['apps', 'currentAppId'])}`,
      state,
      dispatch,
      isLoading: _.get(state, ['ui', 'isModalLoading'], false),
    }
  })
)(_PremiumChangeDialog)

const _PremiumCalErrorDialog = ({ isOpen, isLoading, currentAppId, onExit, dispatch }) => {
  let bodyContent = <p>กรุณากดปุ่ม ยืนยัน เพื่อลองอีกครั้ง หรือ กดปุ่ม X เพื่อกลับสู่เมนูหลัก</p>
  let footerContent = (
    <div className="bottom">
      <Button
        color="primary"
        onClick={() => {
          dispatch(reValidateAge(currentAppId))
        }}
      >
        ยืนยัน
      </Button>
    </div>
  )

  return (
    <PremiumChangeModal isOpen={isOpen} backdrop={true} size="md" modalClassName="default-bootstrap">
      <ModalHeader tag="div">
        <div />
        <div>ขณะนี้ระบบไม่สามารถใช้งานได้</div>
        <div
          className="btn-right"
          onClick={() => {
            dispatch(changeCurrentApp(''))
            onExit()
          }}
        >
          <Icon.close className="icon" />
        </div>
      </ModalHeader>
      <ModalBody>{bodyContent}</ModalBody>
      <ModalFooter>{footerContent}</ModalFooter>
    </PremiumChangeModal>
  )
}

export const PremiumCalErrorDialog = compose(
  withRouter,
  withHandlers({
    onExit: ({ history }) => () => {
      history.push('/')
    },
  }),
  connect((state, dispatch) => {
    return {
      isOpen:
        _.get(state, ['apps', 'byId', `${_.get(state, ['apps', 'currentAppId'])}`, 'checkedPremiumCalStatus'], 'Y') ===
        'API Error',
      state,
      dispatch,
      currentAppId: `${_.get(state, ['apps', 'currentAppId'])}`,
      isLoading: _.get(state, ['ui', 'isModalLoading'], false),
    }
  })
)(_PremiumCalErrorDialog)

/* istanbul ignore next */
export const AppInformation = compose(
  setDisplayName('AppInformation'),
  withRouter,
  connect(getPreparedAppInformation),
  withHandlers({
    onClick: ({
      appId,
      dispatch,
      history,
      status,
      remoteSelling,
      quickQuote,
      activeDiscountList,
      canProceed,
    }) => () => {
      const user = JSON.parse(localStorage.getItem('userInfo'))
      const selectedRidersHasCampaignDiscount = quickQuote.biProps.riders
        ? quickQuote.biProps.riders.filter((rider) => rider.campaignDiscount && rider.fullPremium)
        : []
      const filterSelectedRiderCampaignDiscountOutDate =
        selectedRidersHasCampaignDiscount.length > 0
          ? selectedRidersHasCampaignDiscount.filter((rider) =>
              moment()
                .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
                .isAfter(
                  moment(
                    getToggles().OUT_OF_DATE_RIDER_CAMPAIGN_DISCOUNT ? '01/01/2025' : rider.campaignDiscount.endDate,
                    'DD/MM/YYYY'
                  ).set({
                    hour: 23,
                    minute: 59,
                    second: 59,
                    millisecond: 999,
                  })
                )
            )
          : []

      if (
        ((quickQuote.coveragePlan.selectedBasicPlan &&
          quickQuote.coveragePlan.selectedBasicPlan.campaignDiscountEndDate &&
          moment().isAfter(
            moment(quickQuote.coveragePlan.selectedBasicPlan.campaignDiscountEndDate, 'DD/MM/YYYY').set({
              hour: 23,
              minute: 59,
              second: 59,
              millisecond: 999,
            })
          )) ||
          (!quickQuote.coveragePlan.selectedBasicPlan.campaignDiscountEndDate &&
            activeDiscountList[quickQuote.selectedDisplayProduct.code])) &&
        (isNil(status) || status === APP_STATUS.DRAFTED)
      ) {
        const getCampaignMessage = (index) => {
          let campaignMessage = _.get(quickQuote, `coveragePlan.selectedBasicPlan.campaignDiscountMessage[${index}]`)

          if (!campaignMessage) {
            campaignMessage = _.get(activeDiscountList, [
              quickQuote.selectedDisplayProduct.code,
              'campaignDiscountMessage',
              index,
            ])
          }

          return campaignMessage || ''
        }

        dispatch(
          setNotificationMessage({
            type: 'CampaignExpired',
            message: getCampaignMessage(2),
            warningmessage: getCampaignMessage(3),
          })
        )
      } else if (
        (isNil(status) || status === APP_STATUS.DRAFTED) &&
        ((user.productConfigure &&
          user.productConfigure.disableDrafted &&
          user.productConfigure.disableDrafted.includes(quickQuote.selectedDisplayProduct.code)) ||
          canProceed === false)
      ) {
        dispatch(
          setNotificationMessage({
            type: 'CampaignExpired',
            message: 'ท่านไม่สามารถดำเนินการใบคำขอนี้ได้ เนื่องจากเกินระยะเวลาที่กำหนดในการขายผลิตภัณฑ์',
          })
        )
      } else if (
        (isNil(status) || status === APP_STATUS.DRAFTED) &&
        filterSelectedRiderCampaignDiscountOutDate.length > 0
      ) {
        // Rider Campaign Discount Warning Message
        const warningMsg = filterSelectedRiderCampaignDiscountOutDate.map((rider) => {
          return rider.campaignDiscount.campaignDiscountMessage.historyInformationMessage
            ? Mustache.render(_.get(rider.campaignDiscount.campaignDiscountMessage, 'historyInformationMessage'), {
                campaignStartDate: _.get(rider.campaignDiscount, 'startDate')
                  ? christianToThaiDate(_.get(rider.campaignDiscount, 'startDate'), 'DD/MM/YYYY')
                  : '',
                campaignEndDate: _.get(rider.campaignDiscount, 'endDate')
                  ? christianToThaiDate(_.get(rider.campaignDiscount, 'endDate'), 'DD/MM/YYYY')
                  : '',
              })
            : ''
        })
        dispatch(
          setNotificationMessage({
            type: 'CampaignExpired',
            message:
              ' ใบคำขอดังกล่าวไม่อยู่ในช่วงรับส่วนลดค่าเบี้ยประกัน กรุณากดปุ่มยืนยันเพื่อดำเนินการกรอกข้อมูลใบคำขอใหม่อีกครั้ง',
            warningmessage: warningMsg,
          })
        )
      } else if (
        status === APP_STATUS.SIGNED &&
        ((user.productConfigure &&
          user.productConfigure.disableSubmitted &&
          user.productConfigure.disableSubmitted.includes(quickQuote.selectedDisplayProduct.code)) ||
          canProceed === false)
      ) {
        dispatch(
          setNotificationMessage({
            type: 'CampaignExpired',
            message: 'ท่านไม่สามารถดำเนินการส่งใบคำขอนี้ได้ เนื่องจากเกินระยะเวลาที่กำหนดในการขายผลิตภัณฑ์',
          })
        )
      } else {
        if (status === APP_STATUS.SUBMITTED) {
          history.push('form/insured')
        }
        // else if (status === APP_STATUS.SUBMITTED) {
        // history.push('form/insured')
        // }
        dispatch(clickApplicationCard(appId))
      }
    },
  }),
  withProps((appWithID) => {
    let disabled = false
    let statusSigned = null
    const hasDeeplinkAppId = appWithID?.hasDeeplinkAppId || null

    if (appWithID.status === APP_STATUS.SIGNED) {
      const obj = housekeepingStatusSignedFlow(appWithID)
      disabled = obj.disabled
      statusSigned = obj.statusSigned
    } else if (appWithID.status === APP_STATUS.DRAFTED) {
      const obj = housekeepingStatusDraftedFlow(appWithID)
      disabled = obj.disabled
      statusSigned = obj.statusSigned
    }
    return {
      hasDeeplinkAppId,
      disabled,
      statusSigned,
      remoteSellingStatus: get('selectedRemoteSelling', appWithID),
    }
  })
)(ApplicationCard)

const ReplicationMessage = connect((state, { replicationStatus }) => ({
  isLoggedIn: isLoggedIn(state),
  replicationStatus: replicationStatus || getReplicationStatus(state),
}))(_ReplicationMessage)

const NotFound = styled(({ className, history }) => (
  <AppContent className={className}>
    <FormSection>
      <Flex flex="1 0 100%" column>
        <Box flex="0 0 auto">
          <ReplicationMessage />
        </Box>
        <Flex flex="1 0 auto" column justify="center">
          <div className="sale">
            <span className="title">
              ไม่มีใบคำขอเอาประกัน กรุณา login
              <br />
              หรือเปิดการขายด้วยใบเสนอราคา
            </span>
            <br />
            <Button onClick={() => history.replace('/')}>เปิดการขาย ด้วยใบเสนอราคา</Button>
          </div>
        </Flex>
      </Flex>
    </FormSection>
  </AppContent>
))`
  ${FormSection} {
    display: flex;
    flex: 100%;
  }
  .sale {
    text-align: center;
    padding-bottom: ${({ theme }) => theme.variables['$padding-large-vertical']};
    .title {
      font-size: ${({ theme }) => theme.variables['$font-size-h6']};
      display: inline-block;
      padding-bottom: ${({ theme }) => theme.variables['$padding-large-vertical']};
    }
  }
`

const EmptyApp = styled(({ children, ...props }) => <Card {...props}>{`ยังไม่มีเอกสาร${children}`}</Card>).attrs({
  align: 'center',
  justify: 'center',
})`
  height: 120px;
`

const orderByUpdatedAt = orderBy([flow(get('updatedAt'), defaultTo(0))], ['desc'])

const userInfo = JSON.parse(localStorage.getItem('userInfo'))
const user = {
  access_token: _.get(userInfo, ['access_token'], null),
  profile: {
    agent_code: _.get(userInfo, ['agent_code'], null),
    agent_type: _.get(userInfo, ['agent_type'], null),
  },
}

export default compose(
  connect(
    (state) => {
      return {
        ...getAppList(state),
        submittedFlashMessage: submittedFlashMessage(state),
        products: getProductsPayload(state),
        productDisplays: getProductsDisplay(state),
        user,
        isLoading: _.get(state, ['ui', 'isModalLoading'], false),
        isUserLogin: isLoggedIn(state),
      }
    },
    (dispatch) => ({
      subscribeReplicationStatus: () => dispatch(subscribeReplicationStatus()),
      unsubscribeReplicationStatus: () => dispatch(unsubscribeReplicationStatus()),
      listApplication: () => dispatch(fetchApplication()),
      dispatchAnalyticsPageViewEvent: bindActionCreators(analyticsPageViewEvent, dispatch),
      setNotificationMessage: bindActionCreators(setNotificationMessage, dispatch),
      changeCurrentApp: (appId) => {
        dispatch(changeCurrentApp(appId))
      },
      listApplicationSummary: (user) => dispatch(listApplicationSummary(user)),
      mergeApplication: bindActionCreators(mergeApplication, dispatch),
      changeCurrentAppToDefault: () => dispatch(changeCurrentApp('')),
      iProLoadApp: (appId, status) => {
        dispatch(iProLoadApp(appId, status))
      },
      needLogin: bindActionCreators(loginRequest, dispatch),
    })
  ),
  withRouter,
  withState('deeplinkAppId', 'setDeeplinkAppId', null),
  mapProps((props) => ({
    ...props,
  })),
  lifecycle({
    async componentDidMount() {
      this.props.listApplication()

      this.props.subscribeReplicationStatus()
      this.props.dispatchAnalyticsPageViewEvent(this.props.location.pathname)

      const search = getQueryParam(_.get(this.props.location, ['search'], null))
      const deeplinkOptyId = _.get(search, ['opty'], null)
      if (search && !_.isEmpty(search) && deeplinkOptyId) {
        const { response } = await getAppByOptyId(this.props.user, deeplinkOptyId)
        const status = _.get(response, ['status'], null)
        const appId = _.get(response, ['applicationId'], null)

        const deeplinkData = {
          [appId]: {
            ...response,
          },
        }
        deeplinkData[appId]._id = appId

        const listApplicationSummaries = await listApplicationSummary(user)

        if (listApplicationSummaries) {
          const appSummaries = flow(map(omit(['_rev'])), keyBy('_id'))(deeplinkData)
          await mergeApplication(appId, appSummaries)
          this.props.changeCurrentAppToDefault()
          const app = appSummaries[appId]
          if (app && this.props.isUserLogin) {
            this.props.iProLoadApp(appId, status)
          } else {
            this.props.needLogin()
          }
        }
      }
    },
    componentWillUnmount() {
      this.props.unsubscribeReplicationStatus()
    },
    UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.location.pathname !== nextProps.location.pathname) {
        this.props.dispatchAnalyticsPageViewEvent(nextProps.location.pathname)
      }
    },
  }),
  withProps((app) => {
    const drafted = app[APP_STATUS.DRAFTED]
    const signed = app[APP_STATUS.SIGNED]
    const submitted = app[APP_STATUS.SUBMITTED]
    const submitting = [].concat(app[APP_STATUS.SUBMITTING] || [], app[APP_STATUS.FAILED] || [])

    const hasSubmitting = !isEmpty(app[APP_STATUS.SUBMITTING])
    const hasFailed = !isEmpty(app[APP_STATUS.FAILED])
    const orderedSubmitted = orderByUpdatedAt(submitted)
    const hasDeeplinkAppId = app?.deeplinkAppId || null
    const activeDiscountList = {}
    if (drafted && app.products) {
      for (let i = 0; i < drafted.length; i++) {
        const product = app.products.find(
          (product) => product.code === drafted[i].quickQuote.selectedDisplayProduct.code
        )

        if (product && product.campaignDiscount) {
          const campaignDiscount = getActiveBasicPlanCampaignDiscount(product.campaignDiscount)
          if (campaignDiscount && !_.isEmpty(campaignDiscount)) {
            activeDiscountList[drafted[i].quickQuote.selectedDisplayProduct.code] = campaignDiscount
          }
        }
      }
    }
    return {
      hasSubmitting,
      hasFailed,
      sections: [
        {
          title: 'เอกสารระหว่างนำส่ง',
          length: size(submitting),
          list: orderByUpdatedAt(submitting),
          hidden: size(submitting) === 0,
          status: 'submitting',
        },
        {
          title: 'เอกสารระหว่างดำเนินการ',
          length: size(drafted),
          list: orderByUpdatedAt(drafted),
          status: 'drafted',
        },
        {
          title: 'เอกสารเซ็นแล้วรอชำระเบี้ย',
          length: size(signed),
          list: orderByUpdatedAt(signed),
          status: 'signed',
        },
        {
          title: 'เอกสารนำส่งแล้ว',
          length: size(submitted),
          list: orderedSubmitted,
          status: 'submitted',
        },
      ],
      latestSubmitted: head(orderedSubmitted),
      hasDeeplinkAppId,
      activeDiscountList,
    }
  }),
  branch(flow(get('sections'), map('length'), sum, isEqual(0)), renderComponent(withRouter(NotFound)))
)(({ hasSubmitting, hasFailed, sections, latestSubmitted, hasDeeplinkAppId, activeDiscountList }) => (
  <AppContent>
    <EkycRevalidateAge />
    <PremiumCalStatusInvalidDialog />
    <PremiumChangeDialog />
    <PremiumCalErrorDialog />
    <FormSection>
      <ReplicationMessage />
      <CustomerDisclaimerMessage />
      {latestSubmitted && <SubmittedFlashMessage latestSubmitted={latestSubmitted} />}
      {hasFailed && <FailedMessage />}
      {hasSubmitting && <SubmittingMessage />}
      <div className="appWrap">
        {sections.map(({ list = [], title, length, hidden = false, status }, index) => (
          <AppSection key={index} style={{ display: hidden ? 'none' : undefined }}>
            <AppTitle>
              <strong>
                {title} ({length})
              </strong>
              {getToggles().ENABLE_DRAFT_HOUSE_KEEPING ? <UnderTitleStatus status={status} /> : undefined}
            </AppTitle>
            {list.length ? (
              list.map(
                ({
                  _id,
                  selectedRemoteSelling,
                  quickQuote,
                  remoteSelling,
                  isRemoteSelling,
                  ageChange,
                  checkedPremiumCalStatus,
                  canProceed,
                }) => (
                  <AppInformation
                    appId={_id}
                    key={_id}
                    selectedRemoteSelling={selectedRemoteSelling}
                    hasDeeplinkAppId={hasDeeplinkAppId}
                    quickQuote={quickQuote}
                    activeDiscountList={activeDiscountList}
                    remoteSelling={remoteSelling}
                    isRemoteSelling={isRemoteSelling}
                    ageChange={ageChange}
                    checkedPremiumCalStatus={checkedPremiumCalStatus}
                    canProceed={canProceed}
                  />
                )
              )
            ) : (
              <EmptyApp>{title}</EmptyApp>
            )}
          </AppSection>
        ))}
      </div>
    </FormSection>
  </AppContent>
))
